import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import AccountTreeIcon from '@material-ui/icons/AccountTree';

// The catalog-graph page draws nothing without a root entity, and its own nav item links to a bare
// /catalog-graph -- which renders filters over an empty canvas. The plugin exposes no config for a
// default root, so we drop its nav item and link to the domain instead -- which gives the
// top-level map of the platform, which is what someone clicking "Catalog Graph" is actually after.
const CATALOG_GRAPH_ROOT =
  '/catalog-graph?rootEntityRefs%5B%5D=domain%3Adefault%2Fcontextual-targeting' +
  '&maxDepth=1&unidirectional=true&mergeRelations=true&direction=LR&curve=curveMonotoneX';
// Depth 1 on purpose: domain -> its 5 systems, plus the owning team. Depth 2 already pulls in all
// 24 components and their APIs/resources and renders as an unreadable hairball. The MAX DEPTH box
// is the first control on the page, so going deeper is one click away.

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:notifications'); // Using NotificationsSidebarItem manually instead
      nav.take('page:catalog-graph'); // Replaced below with a link that has a root entity

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label="Menu" icon={<MenuIcon />}>
            {nav.take('page:home')}
            {nav.take('page:catalog')}
            {nav.take('page:scaffolder')}
            <SidebarItem
              icon={AccountTreeIcon}
              to={CATALOG_GRAPH_ROOT}
              text="Catalog Graph"
            />
            <SidebarDivider />
            <SidebarScrollWrapper>
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem />
          <SidebarDivider />
          <SidebarGroup
            label="Settings"
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {nav.take('page:app-visualizer')}
            {nav.take('page:user-settings')}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
